import React from "react";
import Header from "../../Components/layouts/Header";
import Input from "../../Components/themes/Input";
const Dashboard = () => {
  return (
    <>
      <Header title="Farmer" subtitle="Dashboard" />
      <section>
        <Input />
        <div className="flex flex-col items-center mx-[5%] gap-y-8 mt-5">
          <div className="flex lg:gap-x-[5%] xl:gap-x-[5%] w-full">
            <div className="flex flex-col flex-1 lg:w-1/2 bg-pink-200">
              <h2 className="text-[#13490A] bg-[#C6EDC0] h-8 flex items-center justify-center font-bold text-base">
                <p className="">General</p>
              </h2>
              <div className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center pl-4">
                <p className="flex flex-1 justify-around">Member Since : <span className="flex-1">12.03.2008</span></p>
              </div>
              <div className="bg-[#DEDEDE] h-8"></div>
              <div className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center pl-4">
                <p className="flex flex-1 justify-around">Last Visited Date :<span className="flex-1">08.07.2022</span></p>
              </div>
              <div className="bg-[#DEDEDE] h-8"></div>
              <div className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center pl-4">
                <p className="flex flex-1 justify-around">Total Farm Area : <span className="flex-1">12(Acer)</span></p>
              </div>
            </div>
            <table className="flex flex-col flex-1 bg-[#6E776D]">
              <tr className="text-[#13490A] bg-[#C6EDC0] h-8  flex items-center justify-center font-bold text-base">
                <th>Current Cultivation</th>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center">
                <td className="flex-1">S.No</td>
                <td className="flex-[3]">Crop Name</td>
                <td className="flex-[2]">Area</td>
                <td className="flex-[4]">Location</td>
              </tr>
              <tr className="bg-[#DEDEDE] h-8 flex justify-between text-[#13490A] text-sm font-semibold">
                <td className="flex-1 w-10 border-r-4 border-[#6E776D]">01</td>
                <td className="flex-[3] w-28 border-r-4 border-[#6E776D]">Maize</td>
                <td className="flex-[2] w-20 border-r-4 border-[#6E776D]">1 Acer</td>
                <td className="flex-[4] w-40">Lonikand,Pune</td>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center">
                <td className="flex-1">02</td>
                <td className="flex-[3]">Paddy</td>
                <td className="flex-[2]">2 Acer</td>
                <td className="flex-[4]">Lonikand,Pune</td>
              </tr>
              <tr className="bg-[#DEDEDE] h-8 flex justify-between text-[#13490A] text-sm font-semibold">
                <td className="flex-1 border-r-4 border-[#6E776D]">03</td>
                <td className="flex-[3] border-r-4 border-[#6E776D]">Onion</td>
                <td className="flex-[2] border-r-4 border-[#6E776D]">2 Acer</td>
                <td className="flex-[4]">Lonikand,Pune</td>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center">
                <td className="flex-1">04</td>
                <td className="flex-[3]">Peas</td>
                <td className="flex-[2]">3 Acer</td>
                <td className="flex-[4]">Lonikand,Pune</td>
              </tr>
            </table>
          </div>
          <div className="flex lg:gap-x-[5%] xl:gap-x-[5%] w-full">
            <table className="flex flex-col flex-1 h-fit bg-[#6E776D]">
              <tr className="text-[#13490A] bg-[#C6EDC0] h-8  flex items-center justify-center font-bold text-base">
                <th>History of Purchase</th>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center justify-center">
                <td className="flex-1">S.No</td>
                <td className="flex-[2]">Date</td>
                <td className="flex-[4]">Products</td>
                <td className="flex-[2]">Price</td>
                <td className="flex-[2]"></td>
              </tr>
              <tr className="bg-[#DEDEDE] h-8 flex  text-[#13490A] text-sm font-semibold justify-center">
                <td className="flex-1 border-r-4 border-[#6E776D]">01</td>
                <td className="flex-[2] border-r-4 border-[#6E776D]">12/03/22</td>
                <td className="flex-[4] border-r-4 border-[#6E776D]">Urea, Complex B</td>
                <td className="flex-[2] border-r-4 border-[#6E776D]">₹803.00</td>
                <td className="flex-[2] flex justify-center items-center">
                  <img src="Images/arrowr.png" alt="arrow" width="20rem" />
                </td>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center justify-center">
                <td className="flex-1">02</td>
                <td className="flex-[2]">12/03/22</td>
                <td className="flex-[4]">Urea, Complex B</td>
                <td className="flex-[2]">₹803.00</td>
                <td className="flex-[2] flex justify-center">
                  <img src="Images/arrowr.png" alt="arrow" width="20rem" />
                </td>
              </tr>
              <tr className="bg-[#DEDEDE] h-8 flex text-[#13490A] text-sm font-semibold justify-center">
                <td className="flex-1 border-r-4 border-[#6E776D]">03</td>
                <td className="flex-[2] border-r-4 border-[#6E776D]">12/03/22</td>
                <td className="flex-[4] border-r-4 border-[#6E776D]">Urea, Complex B</td>
                <td className="flex-[2] border-r-4 border-[#6E776D]">₹803.00</td>
                <td className="flex-[2] flex justify-center items-center">
                  <img src="Images/arrowr.png" alt="arrow" width="20rem" />
                </td>
              </tr>
              <tr className="text-[#13490A] bg-[#6E776D] h-8 font-semibold text-sm flex items-center justify-center">
                <td className="flex-1">04</td>
                <td className="flex-[2]">12/03/22</td>
                <td className="flex-[4]">Urea, Complex B</td>
                <td className="flex-[2]">₹803.00</td>
                <td className="flex-[2] flex justify-center items-center">
                  <img src="Images/arrowr.png" alt="arrow" width="20rem" />
                </td>
              </tr>
            </table>
            <div className="flex flex-col flex-1 h-fit text-center">
              <h2 className="text-[#13490A] bg-[#C6EDC0] h-10 flex items-center justify-center font-bold text-base">
                Other Information
              </h2>
              <div className="text-[#13490A] bg-[#6E776D] h-10 font-semibold text-sm flex justify-around items-center ">
                <p className="flex flex-1 justify-around pl-4">Total Purchases : <span className="flex-1">₹1,73,800.00</span></p>
              </div>
              <div className="bg-[#DEDEDE] text-[#13490A] h-10 font-semibold text-sm flex items-center ">
                <p className="flex flex-1 justify-around pl-4">Credit Limit : <span className="flex-1">₹20,000</span></p>
              </div>
              <div className="text-[#13490A] bg-[#6E776D] h-10 font-semibold text-sm flex items-center ">
                <p className="flex flex-1 justify-around pl-4">Soil Tested :<span className="flex-1">1/03/22</span></p>
              </div>
              <div className="bg-[#DEDEDE] h-10 flex justify-center items-center ">
                <img src="Images/whatsapp.png" alt="whatsapp" width="30rem" />
                <span className="ml-10 font-semibold text-sm">
                  Send Whatsapp Message
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
